import React, { ReactElement, FunctionComponent } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { Wizard, WizardStep as WizardComponentStep } from '@erecruit/ui-kit';
import { useWizardRouting, WizardRoutingStep } from '@erecruit/core';

export interface WizardStep extends WizardComponentStep, WizardRoutingStep {
  content: FunctionComponent;
  width?: number | string;
}

interface RoutedWizardProps {
  isLoading?: boolean;
  width?: string | number;
  steps: WizardStep[];
  showProgress?: boolean;
  header?: React.ReactNode;
  onBack?: (pushPreviousStep: Function) => void;
  onNextStep?: (onNext: Function) => void;
  onSubmit: () => void;
  onExit?: () => void;
}

const RoutedWizard = ({
  isLoading,
  steps,
  onBack,
  onNextStep,
  onSubmit,
  onExit,
  width,
  header,
  showProgress = true,
}: RoutedWizardProps): ReactElement => {
  const [
    progress,
    pushNextStep,
    pushPreviousStep,
    exitWizard,
  ] = useWizardRouting(steps);

  const handleBack = () =>
    onBack ? onBack(pushPreviousStep) : pushPreviousStep();
  const handleNextStep = () =>
    onNextStep ? onNextStep(pushNextStep) : pushNextStep();

  const onExitWizard = () => {
    onExit && onExit();
    exitWizard();
  };

  return (
    <Wizard
      width={width}
      steps={steps}
      header={header}
      progress={progress}
      onNext={handleNextStep}
      onBack={handleBack}
      onClose={onExitWizard}
      onSubmit={onSubmit}
      isLoading={isLoading}
      showProgress={showProgress}
    >
      <Switch>
        {steps.map(step => (
          <Route key={step.title} path={step.route} component={step.content} />
        ))}
        <Redirect
          to={{
            pathname: steps[0].route,
            state: { modal: true },
          }}
        />
      </Switch>
    </Wizard>
  );
};

export default RoutedWizard;
